export default "__VITE_ASSET__$Gfd6i4x__"